import { FC } from "react";

/**
 * Creates a space between two entries in the `Shelf` which spans the remaining width.
 */
export const Spacer: FC = () => {
  return null;
};
